<template>
    <div v-show="showModel" class="popup">
        <van-popup v-model="showModel" position="bottom" :style="{ height: 'calc(100% - 48px)', 'border-top-left-radius': '8px', 'border-top-right-radius': '8px'}" @click-overlay="changeClose">
            <div class="title">
                <span class="title-selector">请选择</span>
                <img @click="changeClose" class="close" src="../../../assets/image/feedback_popup_close.png" alt="">
            </div>
            <div class="block">
                <div class="selector-block">
                    <span class="radio-text" :class="{'text-disabled': checkbox}">{{noSystem.name}}</span>
                    <img @click="changeRadio" class="radio-img" v-if="radio" src="../../../assets/image/feedback_radio_check.png.png" alt="">
                    <img @click="changeRadio" class="radio-img" v-else src="../../../assets/image/feedback_radio.png" alt="">
                </div>
            </div>
            <p class="inc-system-title">涉及系统（可多选）</p>
            <div class="block">
                <div class="selector-block" v-for="(item, index) in systemsList" :key="item.code">
                    <span class="radio-text" :class="{'text-disabled': radio}">{{item.name}}</span>
                    <img @click="changeCheckbox(index)" class="checkbox-img" v-if="item.check" src="../../../assets/image/feedback_checkbox_check.png" alt="">
                    <img @click="changeCheckbox(index)" class="checkbox-img" v-else src="../../../assets/image/feedback_checkbox.png" alt="">
                </div>
            </div>
            <div class="feedback-submit">
                <van-button class="feedback-button" :class="{'feedback-button-disabled': isSubmitDisabled}" @click="submit" type="primary">确定</van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
import api from '../../../service/modules/feedback'
    export default {
        name: 'popup',
        components: {
            
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            parentNoSystem: {
                type: Object,
                default: {}
            },
            parentBusinessType: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                showModel: this.show,
                radio: false,
                checkbox: false,
                noSystem: {name: '不涉及任何业务系统', check: false},
                systemsList: [
                    {name: '投诉系统', check: false},
                    {name: '退货系统', check: false},
                    {name: '诚信系统', check: false},
                    {name: '考核系统', check: false},
                    {name: '文旅网络信息分析系统 ', check: false},
                    {name: '团队监管系统', check: false},
                    {name: '博物馆系统', check: false},
                    {name: '招商引资系统', check: false},
                    {name: '景区管理系统', check: false},
                    {name: '资源管理系统', check: false},
                    {name: '机构及用户管理系统', check: false},
                ]
            }
        },
        computed: {
            isSubmitDisabled() {
                return !this.radio && !this.checkbox
            }
        },
        watch: {
            show (newVal, oldVal) {
                console.log(newVal, oldVal)
                this.showModel = newVal
                if (this.showModel &&  !this.parentBusinessType.length && !Object.keys(this.parentNoSystem).length) {
                    this.radio = false
                    this.checkbox = false
                    this.systemsList.map(item => {
                        item.check = false
                        return item
                    })
                }
            }
        },
        methods: {
            changeCheckbox(index) {
                if (this.radio) {
                    return false
                }
                

                this.$set(this.systemsList[index], 'check', !this.systemsList[index].check)
                if (!this.checkbox) {
                    this.checkbox = true
                }

                let bool = this.systemsList.every(item => !item.check)
                if (bool) {
                    this.checkbox = false
                }
                this.$forceUpdate();
                console.log(this.checkbox)
            },
            changeRadio() {
                if (this.checkbox) {
                    return false
                }

                this.radio = !this.radio

                if (this.radio) {
                    this.systemsList.forEach(item => {
                        item.check = false
                    })
                    this.checkbox = false
                }
            },
            submit() {
                if (!this.isSubmitDisabled) {
                    if (this.radio) {
                        this.$emit("change-seletor", this.noSystem)
                    } else {
                        this.$emit("change-seletor", this.systemsList.filter(item => item.check))
                    }

                    this.showModel = false
                }
            },
            changeClose() {
                this.$emit("change-close")
            },
            systemList() {
                api.systemList().then(res => {
                    this.noSystem = res.data.filter(item => item.code === 'none')[0];
                    this.systemsList = res.data.filter(item => item.code !== 'none');
                    this.noSystem.check = false;
                    this.systemsList.map(item => {
                        item.check = false
                        return item
                    })
                    console.log(this.noSystem);
                    console.log(this.systemsList)
                })
            }
        },
        created() {
            this.systemList()
        },
        mounted() {
            
        }
    }
</script>

<style lang="less" scoped>
    .popup{
        width: 100%;
        height: 100%;
        position: relative;
        
        /deep/ .van-overlay{
            background: rgba(0,0,0,0.30);
        }
        /deep/ .van-popup{
            padding: 20px 16px 0;
            padding-bottom: 90px;
            box-sizing: border-box;
        }
        .feedback-submit{
            width: 100%;
            height: 90px;
            background-color: #fff;
            position: fixed;
            bottom: 0;
            left: 0;
            padding: 0 16px;
            .feedback-button{
                width: 100%;
                margin-top: 8px;
                font-size: 16px;
                font-family: PingFangSC-Medium;
            }
            .feedback-button-disabled{
                opacity: 0.5;
            }
            /deep/ .van-button{
                border-radius: 4px;
            }
        }
        .title{
            display: flex;
            justify-content: space-between;
            margin-bottom: 4px;
        }
        .title-selector{
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #171A1D;
        }
        .close{
            width: 16px;
            height: 16px;
        }
        .block{
            background: #F5F6F9;
            border-radius: 4px;
            padding: 16px;
            margin-top: 16px;
            .selector-block{
                display: flex;
                justify-content: space-between;
                margin-top: 30px;
                &:nth-child(1){
                    margin-top: 0;
                }
                .radio-img{
                    width: 18px;
                    height: 18px;
                }
                .checkbox-img{
                    width: 16px;
                    height: 16px;
                }
                .radio-text{
                    font-size: 16px;
                    color: #171A1D;
                }
                .text-disabled{
                    color: #ccc;
                }
            }
        }
        .inc-system-title{
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #171A1D;
            margin-top: 20px;
        }
    }
</style>